import React from 'react'
import Slider from 'react-slick';
import { Link } from 'react-router-dom'
import { path } from 'Utils';
import { LazyLoadImage } from 'Blocks'
import config from 'Config'
 
const TheLook = props => {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              centerPadding: '20px',
              slidesToShow: 2.5
            }
          },
          {
            breakpoint: 580,
            settings: {
              centerMode: true,
              centerPadding: '10px',
              slidesToShow: 1.15
            }
          }
        ]
    };

    const gSettings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            centerPadding: '20px',
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 580,
          settings: {
            centerMode: true,
            centerPadding: '10px',
            slidesToShow: 1.15
          }
        }
      ]
  };

    const LoadSlider = () => {
      return (
        <div className={props.className}>
            <div className="content-slider-section">
                <div className="section-container-1140">
                    <div className="section-heading-vertical">{props.data.data.title}</div>
                    <Slider {...settings} className="section-slider-row slick-dotted">
                    {props.data.data.looks.map((k, index) => (
                        <div className="slider-card" key={`tl-${index}`}>
                          <div className="slider-card-image-block">
                              <a href={k.url} target='_blank' className="slider-card-user-link">
                                <LazyLoadImage
                                  alt={k.title}
                                  width={props.screenType === 'small' ? 243 : 272}
                                  height={props.screenType === 'small' ? 302 : 338}
                                  image={k.murl}
                                  className="global-image"
                                  useOriginal={true}
                                />
                              </a>
                          </div>
                          <div className="slider-card-user"><a href={k.url} target='_blank' className="slider-card-user-link">{k.title}</a></div>
                        </div>
                    ))}
                    </Slider>
                </div>
            </div>
        </div>
      )
    }

    const LoadLookV2 = () => {
      return (
        <div className={props.className}>
          <div className="content-slider-section">
            <div className="section-container">
              <div className="content-slider-header">
                {props.data.data.title && props.data.data.title !== "" &&
                  <div className="content-slider-header-title">{props.data.data.title}</div>
                }

                {props.data.data.subTitle && props.data.data.subTitle !== "" &&
                  <div className="content-slider-header-description">{props.data.data.subTitle}</div>
                }
              </div>

               <Slider {...gSettings} className="section-slider-row slider-mobile-row">
                {props.data.data.looks.map((k, index) => (
                  <div className="slider-card">
                    <div className="slider-card-image-block">
                      <a href={k.url} target='_blank' className="slider-card-user-link">
                        <LazyLoadImage
                          alt={k.title}
                          width={props.screenType === 'small' ? 243 : 272}
                          height={props.screenType === 'small' ? 302 : 338}
                          image={k.murl}
                          className="global-image"
                          useOriginal={true}
                        />
                      </a>
                    </div>
                    <div className="slider-card-user">
                      <a href={k.url} target='_blank' className="slider-card-user-link">{k.title}</a>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      )
    }

    const LoadLookV3 = () => {
      const settings = {
        dots: true,
        appendDots: (dots) => (
          <div style={{ display: "flex" }}>
            {dots}
          </div>
        ),
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              centerPadding: '20px',
              slidesToShow: 2.5
            }
          },
          {
            breakpoint: 580,
            settings: {
              centerMode: true,
              centerPadding: '10px',
              slidesToShow: 1.3
            }
          }
        ]
      }
      return (
        <div className={props.className}>
          <div className="product-slider-section theme-linen">
            <div className="section-container">
              <div className="content-slider-header">
                <div className="slider-section-heading">{props.data.data.title}</div>
              </div>
              <Slider {...settings} className="product-section-slider-row slick-dotted">
              {props.data.data.looks.map((k, index) => (
                <div className="slider-card" key={`tl-${index}`}>
                  <div className="slider-card-image-block">
                      <a href={k.url} target='_blank'>
                        <LazyLoadImage
                          alt={k.title}
                          width={props.screenType === 'small' ? 243 : 282}
                          height={props.screenType === 'small' ? 302 : 338}
                          image={k.murl}
                          className="global-image"
                          style={{width: props.screenType === 'small' ? 243 : 282, height: props.screenType === 'small' ? 302 : 338}}
                          useOriginal={true}
                        />
                      </a>
                  </div>
                  <div className="slider-card-user"><a href={k.url} target='_blank' className="slider-card-user-link">{k.title}</a></div>
                </div>
              ))}
              </Slider>
            </div>
          </div>
        </div>
      )
    }

    const sliderDetails = {
      sb: <LoadSlider />,
      hc: <LoadLookV2 />,
      us: <LoadLookV3 />
    }

    return sliderDetails[config.name]
}

export default TheLook
